import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { getFile } from "../../../services/core/celeryFileService";
import { exportTeamResultsExcel } from "../../../services/olympiad/results";
import { toast } from "react-toastify";

const INTERVAL_TIME = 3 * 1000;
const REQUEST_LIMIT = 60;

export default function ExportExcel({ params }) {
  const [t] = useTranslation();

  const [loadingFile, setLoadingFile] = useState(false);

  const handle = () => {
    setLoadingFile(true);

    let request_counter = 0;

    exportTeamResultsExcel(params).then((res) => {
      const intervalId = setInterval(() => {
        if (request_counter >= REQUEST_LIMIT) {
          clearInterval(intervalId);
          toast.error(t("examinations.failure"));
          setLoadingFile(false);
        }

        getFile({ uuid: res?.uuid }).then((res) => {
          if (res?.status === 1) {
            window.location.href = res?.file;
            clearInterval(intervalId);
            setLoadingFile(false);
          }
        });

        request_counter++;
      }, INTERVAL_TIME);
    });
  };

  return (
    <Button
      // disabled={true}
      type="button"
      text="Загрузить"
      color="success"
      Icon={ArrowDownTrayIcon}
      loading={loadingFile}
      onClick={() => handle()}
    />
  );
}
